define(
    'NMSDesignSystem.CrossAppWarmup',
    [],
    function NMSDesignSystemCrossAppWarmup() {
        'use strict';

        var localPreviewPattern = /\/(shopping|checkout|my_account)-local\.ssp$/i;
        var localAssetOrigin = 'http://localhost:7777';
        var warmedResources = {};
        var warmupTimer;
        var observer;

        function localPreviewApp(url) {
            var match;

            try {
                match = new URL(url, window.location.href).pathname.match(localPreviewPattern);
            } catch (error) {
                return '';
            }

            if (!match) return '';
            return match[1] === 'my_account' ? 'myaccount' : match[1].toLowerCase();
        }

        function isLocalPreview() {
            return !!localPreviewApp(window.location.href);
        }

        function localPreviewDocument(app) {
            var fileName = app === 'myaccount' ? 'my_account' : app;
            var directory = window.location.pathname.replace(localPreviewPattern, '/');

            return window.location.origin + directory + fileName + '-local.ssp';
        }

        function shoppingRoute(url) {
            var route = url.pathname + url.search;

            if (route === '/') return '/';
            return route.charAt(0) === '/' ? route : '/' + route;
        }

        function pointsToShopping(anchor, url, currentApp) {
            if (currentApp === 'shopping' || url.origin !== window.location.origin) return false;
            if (/\/goToCart\.ssp$/i.test(url.pathname)) return true;
            return anchor.matches(
                '.nms-header-logo-link, ' +
                '.nms-header-menu-link, ' +
                '.nms-header-products-link, ' +
                '.nms-header-cart-trigger, ' +
                '.nms-header-mini-cart-item-image, ' +
                '.nms-header-mini-cart-item-name, ' +
                '[data-touchpoint="home"]'
            );
        }

        function localizeCrossAppHref(anchor) {
            var href = anchor.getAttribute('href');
            var currentApp = localPreviewApp(window.location.href);
            var touchpoint = anchor.getAttribute('data-touchpoint');
            var hashtag = anchor.getAttribute('data-hashtag');
            var localHash;
            var url;

            if (!href || !currentApp) return;

            if (touchpoint === 'customercenter') {
                localHash = hashtag
                    ? (hashtag.charAt(0) === '#'
                        ? hashtag
                        : '#' + (hashtag.charAt(0) === '/' ? hashtag : '/' + hashtag))
                    : '#/overview';
                anchor.setAttribute(
                    'href',
                    localPreviewDocument('myaccount') + localHash
                );
                anchor.setAttribute('data-navigation', 'ignore-click');
                return;
            }

            if (touchpoint === 'viewcart' && currentApp !== 'shopping') {
                anchor.setAttribute('href', localPreviewDocument('shopping') + '#/cart');
                anchor.setAttribute('data-navigation', 'ignore-click');
                return;
            }

            try {
                url = new URL(href, window.location.href);
            } catch (error) {
                return;
            }

            if (url.origin !== window.location.origin) return;
            if (localPreviewApp(url.href)) return;

            if (/\/my_account\.ssp$/i.test(url.pathname)) {
                url.pathname = url.pathname.replace(/my_account\.ssp$/i, 'my_account-local.ssp');
                anchor.setAttribute('href', url.href);
                return;
            }

            if (/\/checkout\.ssp$/i.test(url.pathname)) {
                url.pathname = url.pathname.replace(/checkout\.ssp$/i, 'checkout-local.ssp');
                anchor.setAttribute('href', url.href);
                return;
            }

            if (/\/shopping\.ssp$/i.test(url.pathname)) {
                url.pathname = url.pathname.replace(/shopping\.ssp$/i, 'shopping-local.ssp');
                anchor.setAttribute('href', url.href);
                return;
            }

            if (pointsToShopping(anchor, url, currentApp)) {
                anchor.setAttribute(
                    'href',
                    localPreviewDocument('shopping') + '#' +
                        (/\/goToCart\.ssp$/i.test(url.pathname) ? '/cart' : shoppingRoute(url))
                );
            }
        }

        function crossAppLinks() {
            return document.querySelectorAll(
                '#site-header a[href], ' +
                '.nms-header-nav a[href], ' +
                'a[data-touchpoint="home"][href], ' +
                'a[data-touchpoint="customercenter"][href], ' +
                'a[data-touchpoint="viewcart"][href], ' +
                'a[data-touchpoint="checkout"][href]'
            );
        }

        function syncLocalCrossAppLinks() {
            if (!isLocalPreview()) return;
            Array.prototype.forEach.call(crossAppLinks(), localizeCrossAppHref);
        }

        function addPrefetch(href, as) {
            var link;

            if (!href || warmedResources[href]) return;
            warmedResources[href] = true;
            link = document.createElement('link');
            link.rel = 'prefetch';
            link.href = href;
            link.setAttribute('fetchpriority', 'low');
            link.setAttribute('data-nms-cross-app-warmup', 'true');
            if (as) link.as = as;
            document.head.appendChild(link);
        }

        function warmLocalAssets(app) {
            var prefix = localAssetOrigin + '/tmp/';
            var touchpoint = app === 'myaccount' ? 'myaccount' : app;

            addPrefetch(prefix + 'css/' + touchpoint + '.css', 'style');
            addPrefetch(prefix + touchpoint + '-templates.js', 'script');
            addPrefetch(prefix + 'extensions/' + touchpoint + '_ext.js', 'script');
        }

        function warmAnchor(anchor) {
            var currentApp = localPreviewApp(window.location.href);
            var targetApp;
            var url;

            if (!currentApp || !anchor || !anchor.href) return;
            localizeCrossAppHref(anchor);

            try {
                url = new URL(anchor.href, window.location.href);
            } catch (error) {
                return;
            }

            targetApp = localPreviewApp(url.href);
            if (!targetApp || targetApp === currentApp) return;

            url.hash = '';
            addPrefetch(url.href, 'document');
            warmLocalAssets(targetApp);
        }

        function warmHeaderTargets() {
            syncLocalCrossAppLinks();
            Array.prototype.forEach.call(crossAppLinks(), warmAnchor);
        }

        function scheduleWarmup() {
            if (!isLocalPreview() || warmupTimer) return;

            warmupTimer = window.setTimeout(function waitForIdleWarmup() {
                warmupTimer = null;
                if (window.requestIdleCallback) {
                    window.requestIdleCallback(warmHeaderTargets, {timeout: 1600});
                } else {
                    warmHeaderTargets();
                }
            }, 600);
        }

        function eventAnchor(event) {
            var target = event.target;

            if (!target || !target.closest) return null;
            return target.closest(
                '#site-header a[href], ' +
                '.nms-header-nav a[href], ' +
                'a[data-touchpoint="home"][href], ' +
                'a[data-touchpoint="customercenter"][href], ' +
                'a[data-touchpoint="viewcart"][href], ' +
                'a[data-touchpoint="checkout"][href]'
            );
        }

        function warmFromIntent(event) {
            warmAnchor(eventAnchor(event));
        }

        function installLinkObserver() {
            var header = document.querySelector('#site-header') || document.querySelector('.nms-header-nav');

            if (!header || observer || !window.MutationObserver) return;
            observer = new window.MutationObserver(function headerChanged() {
                syncLocalCrossAppLinks();
            });
            observer.observe(header, {childList: true, subtree: true});
        }

        return {
            mountToApp: function mountToApp(container) {
                var layout;

                if (!isLocalPreview() || window.NMSCrossAppWarmupInstalled) return;
                window.NMSCrossAppWarmupInstalled = true;
                layout = container && container.getComponent
                    ? container.getComponent('Layout')
                    : null;

                syncLocalCrossAppLinks();
                installLinkObserver();
                scheduleWarmup();
                document.addEventListener('pointerover', warmFromIntent, true);
                document.addEventListener('focusin', warmFromIntent, true);
                document.addEventListener('touchstart', warmFromIntent, {capture: true, passive: true});

                if (layout) {
                    layout.on('afterShowContent', function maintainCrossAppWarmup() {
                        syncLocalCrossAppLinks();
                        installLinkObserver();
                        scheduleWarmup();
                    });
                }
            }
        };
    }
);
